import { Layout } from "Components/Layout/Layout";
import { OwnersContainer } from "Containers/Owners/OwnersContainer";
import React from "react";

export const Owners = () => {
  return (
    <Layout>
      <OwnersContainer />
    </Layout>
  );
};
